module.exports = __webpack_public_path__ + "static/media/ti_logo.470c9faa.png";